import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

type APEntryParamsProps = {
  onSubmittedID: (submittedID: string) => void;
  onDraftID: (draftID: string) => void;
};

const APEntryParams = ({ onSubmittedID, onDraftID }: APEntryParamsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const clearParam = (param: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete(param);

    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    const submittedID = searchParams.get('submittedID');
    const draftID = searchParams.get('draftID');

    if (submittedID) {
      onSubmittedID(submittedID);
      clearParam('submittedID');
      return;
    }

    if (draftID) {
      onDraftID(draftID);
      clearParam('draftID');
    }
  }, [searchParams]);

  return <span />;
};

export default APEntryParams;
